module.exports = __webpack_public_path__ + "static/media/dmc-group-banner.9053f2e6.png";